const Footer = () => {
  return (
    <div className='footer'>
      <center>
        <div className='footer-left'>
          <div className='footer-entry'><a href='https://activistmailer.com/frequently-asked-questions/'>FAQs</a></div>
          <div className='footer-entry'><a href='https://activistmailer.com/support-page/'>Support</a></div>
          <div className='footer-entry'><a href='https://activistmailer.com/contact-us/'>Contact Us</a></div>
          <div className='footer-entry'><a href='https://activistmailer.com/about-us-2/'>About Us</a></div>
          <div className='footer-entry'><a href='https://activistmailer.com/privacy-policy/'>Privacy</a></div>
          <div className='footer-entry'><a href='https://activistmailer.com/terms-of-service/'>Terms of Service</a></div>
        </div>
        <div className='footer-right'>
          <div style={{color: '#f4f4f4', marginLeft: '50px', paddingLeft: '120px', display: 'inline'}}>All rights reserved © 2024-2026</div>
        </div>
      </center> 
    </div>
  );
}

export default Footer;
